/* =================================================================
   norsu "Drop a hint" — landing page (the buyer's screen)
   File: assets/norsu-hint-landing.js
   Pairs with sections/norsu-hint-landing.liquid

   Reads the hint out of the query string, shows the note, then adds the
   item(s) + free gift wrapping + an optional card to the cart in a single
   /cart/add.js and opens the slide cart — the same path the PDP cross-sell
   card and the Spin Me upsell use (snippets/norsu-addons.liquid).
   ================================================================= */
(function () {
  'use strict';

  var root = document.querySelector('[data-nhl]');
  if (!root) return;

  var cfg = {};
  try { cfg = JSON.parse(root.getAttribute('data-nhl-config') || '{}'); } catch (e) { cfg = {}; }

  var MAX_ITEMS = 8;
  var hint = {};        /* from / to / note / source */
  var rows = [];        /* { product, variants, selectedId, selected, available } */

  /* ---------- helpers ---------------------------------------------- */

  function money(cents) {
    return '$' + (Number(cents || 0) / 100).toFixed(2).replace(/\.00$/, '');
  }

  function thumb(url, size) {
    if (!url) return '';
    var u = url.indexOf('//') === 0 ? 'https:' + url : url;
    return u.replace(/(\.[a-z]{3,4})(\?|$)/i, '_' + (size || 400) + 'x$1$2');
  }

  function el(sel) { return root.querySelector(sel); }

  function show(sel, on) {
    var n = el(sel);
    if (n) n.hidden = !on;
  }

  /* Strip anything that isn't a plain name — the note and names land in the
     DOM as textContent only, never innerHTML, but keep them sane anyway. */
  function clean(v, max) {
    return String(v || '').replace(/\s+/g, ' ').trim().slice(0, max || 80);
  }

  function parse() {
    var q = new URLSearchParams(location.search);
    hint = {
      from: clean(q.get('f'), 40),
      to: clean(q.get('t'), 40),
      note: clean(q.get('m'), 280),
      source: q.get('s') || 'pdp'
    };
    var handles = (q.get('p') || '').split(',').map(function (h) {
      return h.trim().replace(/[^a-z0-9\-_]/gi, '');
    }).filter(Boolean).slice(0, MAX_ITEMS);
    var variants = (q.get('v') || '').split(',').map(function (v) { return v.trim(); });
    return handles.map(function (h, i) {
      return { handle: h, variantId: /^\d+$/.test(variants[i] || '') ? variants[i] : '' };
    });
  }

  /* ---------- the note -------------------------------------------- */

  function renderNote() {
    var who = hint.from || 'Someone';
    var eyebrow = hint.to ? ('A hint for ' + hint.to) : 'A hint for you';
    var title = rows.length > 1
      ? (who + ' has their eye on a few things')
      : (who + ' has their eye on this');

    el('[data-nhl-eyebrow]').textContent = eyebrow;
    el('[data-nhl-title]').textContent = title + '.';

    if (hint.note) {
      var msg = el('[data-nhl-msg]');
      msg.querySelector('[data-nhl-msg-text]').textContent = '“' + hint.note + '”';
      msg.querySelector('[data-nhl-msg-cite]').textContent = hint.from ? ('— ' + hint.from) : '';
      msg.hidden = false;
    }

    el('[data-nhl-lede]').textContent = cfg.card
      ? 'Everything’s here — wrapped free, with a card if you’d like one.'
      : 'Everything’s here, wrapped free.';

    show('[data-nhl-note]', true);
  }

  /* ---------- items ----------------------------------------------- */

  function rowMarkup(row, index, multi) {
    var p = row.product;
    var v = currentVariant(row);
    var img = thumb(p.featured_image || (p.images && p.images[0]), 400);
    var hasOptions = (p.variants || []).length > 1;
    var onSale = v && v.compare_at_price && v.compare_at_price > v.price;

    var html = '';
    if (multi) {
      html +=
        '<span class="nhl-item__pick">' +
          '<input type="checkbox" id="nhl-pick-' + index + '" data-nhl-pick="' + index + '"' + (row.selected ? ' checked' : '') + (row.available ? '' : ' disabled') + '>' +
          '<label class="nhl-item__box" for="nhl-pick-' + index + '" aria-label="Include this item">' +
            '<svg viewBox="0 0 12 12" width="11" height="11"><path d="M1 6.2 4.3 9.4 11 2.6" fill="none" stroke="#fff" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>' +
          '</label>' +
        '</span>';
    }
    html +=
      '<a class="nhl-item__media" href="' + p.url + '">' + (img ? '<img src="' + img + '" alt="" loading="lazy" width="92" height="92">' : '') + '</a>' +
      '<div class="nhl-item__body">' +
        (index === 0 && !multi ? '<span class="nhl-item__wanted">On their wishlist</span>' : '') +
        '<a class="nhl-item__title" href="' + p.url + '" data-nhl-row-title></a>' +
        (hasOptions ? '<span class="nhl-item__sel"><select data-nhl-variant="' + index + '" aria-label="Choose an option"></select></span>' : '') +
        '<p class="nhl-item__price" data-nhl-row-price>' + money(v ? v.price : p.price) +
          (onSale ? '<span class="nhl-item__was">' + money(v.compare_at_price) + '</span>' : '') +
        '</p>' +
        (row.available ? '' : '<p class="nhl-item__oos">Sold out — nothing we can do about this one, sorry.</p>') +
      '</div>';
    return html;
  }

  function currentVariant(row) {
    var list = row.product.variants || [];
    if (!list.length) return null;
    var found = list.filter(function (v) { return String(v.id) === String(row.selectedId); })[0];
    return found || list[0];
  }

  function renderItems() {
    var wrap = el('[data-nhl-items]');
    var multi = rows.length > 1;
    wrap.innerHTML = '';

    rows.forEach(function (row, i) {
      var cell = document.createElement('div');
      cell.className = 'nhl-item';
      cell.setAttribute('data-nhl-row', i);
      cell.setAttribute('data-selected', row.selected ? 'true' : 'false');
      cell.setAttribute('data-unavailable', row.available ? 'false' : 'true');
      cell.innerHTML = rowMarkup(row, i, multi);

      /* textContent, never innerHTML — product titles contain en dashes and
         ampersands and are not ours to trust blindly. */
      cell.querySelector('[data-nhl-row-title]').textContent = row.product.title;

      var sel = cell.querySelector('[data-nhl-variant]');
      if (sel) {
        (row.product.variants || []).forEach(function (v) {
          var o = document.createElement('option');
          o.value = v.id;
          o.textContent = v.title + (v.available ? '' : ' — sold out');
          o.disabled = !v.available;
          if (String(v.id) === String(currentVariant(row).id)) o.selected = true;
          sel.appendChild(o);
        });
      }
      wrap.appendChild(cell);
    });

    show('[data-nhl-items]', true);
  }

  /* ---------- totals ---------------------------------------------- */

  function selectedRows() {
    return rows.filter(function (r) { return r.selected && r.available; });
  }

  function cardTicked() {
    var c = el('[data-nhl-card-check]');
    return !!(c && c.checked && cfg.card);
  }

  function updateTotal() {
    var cents = selectedRows().reduce(function (a, r) {
      var v = currentVariant(r);
      return a + (v ? v.price : 0);
    }, 0);
    if (cardTicked()) cents += Number(cfg.card.price) || 0;

    var btn = el('[data-nhl-buy]');
    var label = el('[data-nhl-buy-label]');
    var total = el('[data-nhl-total]');
    var n = selectedRows().length;

    if (label) label.textContent = n > 1 ? ('Add ' + n + ' items to cart') : 'Add to cart';
    if (total) total.textContent = cents ? money(cents) : '';
    if (btn) btn.disabled = !n;
  }

  /* ---------- gift message prefill -------------------------------- */

  function prefillWrapMessage() {
    var box = el('[data-nhl-wrap-msg]');
    if (!box) return;
    box.placeholder = 'Write something for the card…';
    if (hint.from) {
      /* Reads fine completely unedited — a half-finished "To Ashley," on a
         card is worse than no message at all. */
      box.value = 'To ' + hint.from + ' — hope this is just what you were hoping for. x';
    }
  }

  /* ---------- add to cart ----------------------------------------- */

  function err(msg) {
    var box = el('[data-nhl-err]');
    if (!box) return;
    box.textContent = msg || '';
    box.hidden = !msg;
  }

  function addToCart() {
    err('');
    var picked = selectedRows();
    if (!picked.length) return;

    var wrapOn = !!(el('[data-nhl-wrap-check]') && el('[data-nhl-wrap-check]').checked);
    var wrapMsg = el('[data-nhl-wrap-msg]') ? el('[data-nhl-wrap-msg]').value.trim() : '';

    var items = picked.map(function (r) {
      var props = {};
      if (wrapOn) {
        /* Exactly the property names snippets/norsu-gift-wrap.liquid submits, so
           the cart drawer, checkout and the packing slip all render them. */
        props['Gift wrapping'] = 'Yes please';
        if (wrapMsg) props['Gift message'] = wrapMsg;
      }
      /* Underscore-prefixed = hidden from the shopper, visible on the order. */
      props['_hint_from'] = hint.from || 'a friend';
      props['_hint_source'] = hint.source === 'wishlist' ? 'wishlist' : 'pdp';
      return { id: Number(currentVariant(r).id), quantity: 1, properties: props };
    });

    if (cardTicked()) {
      items.push({
        id: Number(cfg.card.variantId),
        quantity: 1,
        properties: {
          /* Same keys the existing add-on attach scorecard reads. */
          '_addon': 'hint-card',
          '_addon_from': 'hint-landing',
          '_hint_from': hint.from || 'a friend'
        }
      });
    }

    var btn = el('[data-nhl-buy]');
    var label = el('[data-nhl-buy-label]');
    var prev = label ? label.textContent : '';
    if (btn) btn.disabled = true;
    if (label) label.textContent = 'Adding…';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ items: items })
    })
      .then(function (r) { if (!r.ok) throw new Error('cart ' + r.status); return r.json(); })
      .then(function () {
        try {
          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({
            event: 'hint_add_to_cart',
            hint_items: picked.length,
            hint_gift_wrap: wrapOn,
            hint_card: cardTicked(),
            hint_source: hint.source
          });
        } catch (e) {}
        return fetch('/cart.js', { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            var lbl = cart.item_count + ' ' + (cart.item_count === 1 ? 'ITEM' : 'ITEMS');
            document.querySelectorAll('.norsu-cart-item-count').forEach(function (n) { n.textContent = lbl; });
            document.querySelectorAll('[data-cart-count],[data-cart-total],.cart-count,.js-cart-count,.cart-link__count')
              .forEach(function (n) { n.textContent = cart.item_count; });
            ['cart:refresh', 'cart:updated', 'cart:build', 'ajaxCart:afterCartLoad'].forEach(function (ev) {
              document.dispatchEvent(new CustomEvent(ev, { bubbles: true, detail: { cart: cart } }));
            });
          }).catch(function () {});
      })
      .then(function () {
        var t = document.querySelector('.js-mini-cart-trigger, [data-wau-slideout-target="ajax-cart"], .js-slideout-open[data-nv-cart], [data-nv-cart]');
        if (t) { t.click(); } else { window.location.href = '/cart'; }
      })
      .catch(function (e) {
        err('We couldn’t add that to your cart just now. Please try again, or open the product page.');
        if (window.console && console.warn) console.warn('[hint-landing]', e);
      })
      .finally(function () {
        if (btn) btn.disabled = false;
        if (label) label.textContent = prev || 'Add to cart';
        updateTotal();
      });
  }

  /* ---------- bind ------------------------------------------------- */

  function bind() {
    root.addEventListener('change', function (e) {
      var pick = e.target.closest('[data-nhl-pick]');
      if (pick) {
        var i = Number(pick.getAttribute('data-nhl-pick'));
        rows[i].selected = pick.checked;
        var cell = root.querySelector('[data-nhl-row="' + i + '"]');
        if (cell) cell.setAttribute('data-selected', pick.checked ? 'true' : 'false');
        updateTotal();
        return;
      }

      var sel = e.target.closest('[data-nhl-variant]');
      if (sel) {
        var j = Number(sel.getAttribute('data-nhl-variant'));
        rows[j].selectedId = sel.value;
        var v = currentVariant(rows[j]);
        rows[j].available = !!(v && v.available);
        var priceEl = root.querySelector('[data-nhl-row="' + j + '"] [data-nhl-row-price]');
        if (priceEl) {
          var onSale = v && v.compare_at_price && v.compare_at_price > v.price;
          priceEl.innerHTML = money(v ? v.price : 0) +
            (onSale ? '<span class="nhl-item__was">' + money(v.compare_at_price) + '</span>' : '');
        }
        updateTotal();
        return;
      }

      if (e.target.closest('[data-nhl-card-check], [data-nhl-wrap-check]')) updateTotal();
    });

    var buy = el('[data-nhl-buy]');
    if (buy) buy.addEventListener('click', addToCart);
  }

  /* ---------- init -------------------------------------------------- */

  function noindex() {
    /* These links are personal. They're never linked from the site, but make
       the intent explicit rather than relying on that. */
    try {
      var m = document.createElement('meta');
      m.name = 'robots';
      m.content = 'noindex, nofollow';
      document.head.appendChild(m);
    } catch (e) {}
  }

  function finish(ok) {
    show('[data-nhl-loading]', false);
    if (!ok) { show('[data-nhl-empty]', true); return; }
    renderNote();
    renderItems();
    prefillWrapMessage();
    show('[data-nhl-panel]', true);
    updateTotal();
    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ event: 'hint_opened', hint_items: rows.length, hint_source: hint.source });
    } catch (e) {}
  }

  function init() {
    noindex();
    var wanted = parse();
    if (!wanted.length) return finish(false);

    Promise.all(wanted.map(function (w) {
      return fetch('/products/' + w.handle + '.js', { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
        .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
        .then(function (p) {
          var list = p.variants || [];
          var chosen = w.variantId
            ? (list.filter(function (v) { return String(v.id) === String(w.variantId); })[0] || null)
            : null;
          /* No variant named, or the named one has sold out — fall back to the
             first that's actually buyable so the page is never a dead end. */
          if (!chosen || !chosen.available) {
            chosen = list.filter(function (v) { return v.available; })[0] || chosen || list[0] || null;
          }
          return {
            product: p,
            selectedId: chosen ? chosen.id : '',
            selected: true,
            available: !!(chosen && chosen.available)
          };
        })
        .catch(function () { return null; });
    })).then(function (loaded) {
      rows = loaded.filter(Boolean);
      finish(rows.length > 0);
    }).catch(function () { finish(false); });

    bind();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
